// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import VideoFrameProcessorPipelineObserver from './VideoFrameProcessorPipelineObserver';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export default interface DefaultVideoTransformDeviceObserver extends VideoFrameProcessorPipelineObserver {}
